import { useProcessIdOnSingleProcessPage } from "components/CustomGridItems/LotInfoBar/lotInfoUtils";
import CardWithControls from "components/Dashboard/CardWithControls/CardWithControls";
import { HighlightTagsSelector } from "components/Dashboard/HubletView/SingleTimeline/HighlightTagsSelector/HighlightTagsSelector";
import SingleTimeline from "components/Dashboard/HubletView/SingleTimeline/SingleTimeline";
import TimelineCardControls from "components/Dashboard/Timeline/TimelineCardControls/TimelineCardControls";
import Timelines from "components/Dashboard/Timeline/Timelines/Timelines";
import { useExtraTimelineProcessesOnGridPage } from "utils/customHooks/genericHooks";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";
import styled, { FlattenSimpleInterpolation } from "styled-components/macro";
import { getScaleFromWidthForLargeScreens } from "pages/DashboardPages/DashboardPagesContent/dashboardPagesContentUtils";
import { getTimelineChartResponsiveStyles } from "components/Dashboard/styles/getDashboardCardsResponsiveStyles";
import { BREAKPOINT_DESKTOP_XL } from "constants/constants";

export const GridLayoutTimeline = ({ width }: { width: number }) => {
  const { translate } = useFlightTranslation();
  const singleProcessIdOnThisPage = useProcessIdOnSingleProcessPage();
  const extraTimelineProcesses = useExtraTimelineProcessesOnGridPage();

  const scale = getScaleFromWidthForLargeScreens(width);
  return (
    <StyledCardWithControlsGridLayoutTimeline
      title={translate("Timeline")}
      $customCss={`overflow: visible;`}
      CardConfigControls={<TimelineCardControls />}
      {...{ $scale: scale }}
    >
      {extraTimelineProcesses.length === 0 ? (
        <>
          <SingleTimeline containerDimensionsWidth={width} />
          <HighlightTagsSelector />
        </>
      ) : singleProcessIdOnThisPage ? (
        <Timelines
          isCustomDashboardLayout={true}
          processIdsOverride={[
            singleProcessIdOnThisPage,
            ...extraTimelineProcesses.map(p => p.id),
          ]}
        />
      ) : null}
    </StyledCardWithControlsGridLayoutTimeline>
  );
};

const StyledCardWithControlsGridLayoutTimeline = styled(CardWithControls)<{
  $scale: number;
  $customCss?: string | FlattenSimpleInterpolation;
}>`
  @media (min-width: ${BREAKPOINT_DESKTOP_XL}px) {
    ${props => getTimelineChartResponsiveStyles(props.$scale * 1.75)}
    [class*="TimelinesStyles"] .timeline-overflow-wrapper {
      transform-origin: top center;
    }
  }
`;
